export default __webpack_public_path__ + "static/media/instruction_step_3.af3208b0.png";